import { WeeklyCalendarTable } from '../../components/Table/LeaderTable/WeeklyCalendarTable'
import { DailyCalendarTable } from '../../components/Table/LeaderTable/DailyCalendarTable'
import { RequestProps } from '../../store/types'
import { useEffect, useState } from 'react'
import defaultProps from '../../config/defaultProps'
import { Mentee } from '../../store/types/response/LeaderMenteesPlanResponse'
import { useGetLeaderMenteesPlanQuery } from '../../store/redux/reducers/leaderRequestSlice'
import parseMenteeKey from '../../store/utils/parseMenteeKey'
import findEarliestHour from '../../store/utils/findEarliestHour'

type LeaderCalendarProps = {
  isWeeklyRange: boolean
  selectedDate: string
  menteesPlanProps: RequestProps
}

const LeaderCalendar = ({ isWeeklyRange, selectedDate, menteesPlanProps }: LeaderCalendarProps) => {
  const [mentees, setMentees] = useState<Mentee[]>([])
  const [earliestHour, setEarliestHour] = useState(8)

  const { data: menteesPlanResponse, refetch } = useGetLeaderMenteesPlanQuery(
    {
      ...menteesPlanProps,
      ...defaultProps,
    },
    {
      skip: menteesPlanProps.menteesIds?.length === 0,
    }
  )

  useEffect(() => {
    if ((menteesPlanProps.menteesIds?.length ?? 0) > 0) {
      refetch()
    }
  }, [menteesPlanProps, refetch])

  useEffect(() => {
    if (menteesPlanProps.menteesIds?.length === 0) {
      setMentees([])
    }
  }, [menteesPlanProps.menteesIds?.length])

  useEffect(() => {
    if (!menteesPlanResponse?.menteesMapPlannedHours) {
      return
    }

    const parsedMentees = Object.entries(menteesPlanResponse.menteesMapPlannedHours).map(([key, schedule]) => {
      const parsedKey = parseMenteeKey(key)
      return {
        ...parsedKey,
        workSchedule: Object.entries(schedule).map(([date, details]) => ({
          date,
          isVacation: details.isVacation,
          shifts: details.timeSlots || [],
        })),
      }
    })
    setMentees(parsedMentees)
  }, [menteesPlanResponse])

  useEffect(() => {
    setEarliestHour(findEarliestHour(mentees))
  }, [mentees])

  return isWeeklyRange ? (
    <WeeklyCalendarTable selectedDate={selectedDate} mentees={mentees} earliestHour={earliestHour} />
  ) : (
    <DailyCalendarTable selectedDate={selectedDate} mentees={mentees} earliestHour={earliestHour} />
  )
}

export default LeaderCalendar